(ns app.front.view.registration.confirm-email
  (:require [app.front.state-machine :as sm]
            [app.front.validate :as validate :refer [field-invalid-text field-invalid?]]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [re-chain.core :as rc]
            [re-frame.core-instrumented :as rf]
            [reitit.frontend.easy :as rfe]))


(def error-messages {:user/email       [[validate/Email :validate/wrong-email-address]]
                     :terms-checked?   [[validate/True :validate/terms-not-checked]]
                     :privacy-checked? [[validate/True :validate/privacy-not-checked]]})


(def initial-model {:user/email       ""
                    :terms-checked?   false
                    :privacy-checked? false
                    ::state           nil
                    ::terms-visible?  false
                    ::show-errors?    false
                    ::errors          {}})

(def state-machine
  {nil                 {::init ::ready}
   ::ready             {::change-model ::client-validation
                        ::try-submit   ::submitting}
   ::client-validation {::no-errors    ::ready
                        ::still-errors ::client-validation}
   ::submitting        {::submit-email-exists ::email-exists
                        ::submit-success      ::done}
   ::email-exists      {::change-model ::client-validation}})


;; -- Subscriptions -----------------------------------------------------------

(rf/reg-sub ::model
  :-> ::registration-confirm-email)


(rf/reg-sub ::state
  :<- [::model]
  :-> ::state)


(rf/reg-sub ::user-email
  :<- [::model]
  :-> :user/email)


(rf/reg-sub ::show-errors?
  :<- [::model]
  :-> ::show-errors?)


(rf/reg-sub ::submit-disabled?
  :<- [::state]
  :<- [::model]
  (fn [[state model] _]
    (or (= state ::submitting)
        (and (#{::ready ::client-validation} state)
             (or (-> model :terms-checked? not)
                 (-> model :privacy-checked? not)
                 (-> model :user/email str/blank?))))))


(rf/reg-sub ::terms-checked?
  :<- [::model]
  :-> :terms-checked?)


(rf/reg-sub ::privacy-checked?
  :<- [::model]
  :-> :privacy-checked?)


;; -- Events ------------------------------------------------------------------

(def update-next-state (sm/make-update-next-state state-machine
                                                  [::registration-confirm-email ::state]))

(def debug (rf/after (fn [db event]
                       (.log js/console "=======")
                       (.log js/console "state: " (str (-> db ::registration-confirm-email ::state)))
                       (.log js/console "event: " (str event)))))


(def interceptors [(when ^boolean js/goog.DEBUG debug)])


(defn handle-change-model
  [{:keys [db]} [event field value]]
  {:db       (-> db
                 (assoc-in [::registration-confirm-email field] value)
                 (update-next-state event))
   :dispatch [::validate-fields]})


(defn handle-submit-clicked
  [{:keys [db]} _]
  {:db       (assoc-in db [::registration-confirm-email ::show-errors?] true)
   :dispatch (if-not (empty? (validate/validate-form (::registration-confirm-email db) error-messages))
               [::validate-fields]
               [::try-submit])})


(defn handle-validate-fields
  [{:keys [db]} _]
  {:dispatch (if (empty? (validate/validate-form (::registration-confirm-email db) error-messages))
               [::no-errors]
               [::still-errors])})


(defn handle-try-submit
  [{:keys [db]} [event _]]
  {:db           (update-next-state db event)
   :comm/command {:command        :user/send-email-confirmation
                  :data           (select-keys (::registration-confirm-email db) [:user/email])
                  :on-success     [::submit-success]
                  :on-bad-request [::submit-failure]}})


(defn handle-submit-failure [_ [_ status body]]
  (js/console.error "::submit-failure" status body)
  {:dispatch [::submit-email-exists]})


(rf/reg-event-fx ::init
  (fn [{:keys [db]} [event]]
    {:db (-> db
             (assoc ::registration-confirm-email initial-model)
             (update-next-state event))}))


(rf/reg-event-fx ::change-model interceptors handle-change-model)
(rf/reg-event-fx ::validate-fields handle-validate-fields)
(rf/reg-event-fx ::submit-clicked interceptors handle-submit-clicked)

(rf/reg-event-db ::no-errors update-next-state)
(rf/reg-event-db ::still-errors update-next-state)

(rf/reg-event-fx ::try-submit interceptors handle-try-submit)
(rf/reg-event-db ::submit-email-exists interceptors update-next-state)
(rf/reg-event-db ::submit-success interceptors update-next-state)
(rf/reg-event-fx ::submit-failure interceptors handle-submit-failure)


;; Check-session:
(rc/reg-chain
  ::redirect-by-session
  (fn [{:keys [db]} _]
    (when (some? (:session/user db))
      #_{:clj-kondo/ignore [:discouraged-var]}
      (rfe/push-state :dashboard {:branding (:branding db)}))))


;; -- View ------------------------------------------------------------------


(defn accept-checkbox
  [{:keys [id checked on-change disabled text link-text href-params]}]
  [:label.flex.flex-row.items-center.justify-start.self-start
   [cc/checkbox {:id         id
                 :label-text ""
                 :checked    checked
                 :on-change  on-change
                 :disabled   disabled}]
   [:span text
    [:a {:href       (href/href :register nil href-params)
         :tab-index  (when disabled "-1")
         :class-name "ml-1 no-underline hover:underline text-ui-blue"}
     link-text]]])


(defn registration-email-form [validator disabled? input-id-suffix]
  (let [tr               (<sub [:tr])
        show-errors?     (<sub [::show-errors?])
        submit-disabled? (or disabled? (<sub [::submit-disabled?]))
        user-email       (<sub [::user-email])]
    [:form.flex.flex-col.mt-6.items-stretch.self-stretch
     {:on-submit   (fn [e] (.preventDefault e) (>evt [::submit-clicked]))
      :no-validate true}
     [:fieldset
      (if disabled? {:disabled "disabled"} {})
      [:div.flex.mb-6
       (cc/text-input {:id            (str "input-email-register" input-id-suffix)
                       :label-text    (tr [:email-address])                                                                             :light true :type :email
                       :auto-focus    (not disabled?)
                       :class-name    "bg-white py-6 bg-ui-white"
                       :placeholder   (tr [:register/email-placeholder])
                       :default-value user-email
                       :invalid       (field-invalid? show-errors? validator :user/email)
                       :invalid-text  (field-invalid-text show-errors? validator :user/email tr)
                       :on-change     (fn [e] (rf/dispatch-sync [::change-model :user/email (str/lower-case (-> e .-target .-value))]))})]]
     [:div.flex.flex-col.items-stretch.mb-6
      [accept-checkbox {:id          (str "registration-agree-check" input-id-suffix)
                        :checked     (<sub [::terms-checked?])
                        :on-change   #(>evt [::change-model :terms-checked? %])
                        :disabled    disabled?
                        :text        (tr [:register/agree-terms])
                        :link-text   (tr [:register/terms-of-service])
                        :href-params {:terms true}}]
      [accept-checkbox {:id          (str "registration-agree-privacy" input-id-suffix)
                        :checked     (<sub [::privacy-checked?])
                        :on-change   #(>evt [::change-model :privacy-checked? %])
                        :disabled    disabled?
                        :text        (tr [:register/agree-terms])
                        :link-text   (tr [:register/privacy-notice])
                        :href-params {:privacy true}}]
      (when (field-invalid? show-errors? validator :terms-checked?)
        [:div.bx--form-requirement.mb-4.text-center (field-invalid-text show-errors? validator :terms-checked? tr)])
      [:div.flex.items-center.justify-center.mb-6.mt-6
       (cc/button
         {:type       :submit
          :disabled   submit-disabled?
          :class-name "justify-center w-full px-8 bg-ui-night-sky-100 hover:bg-ui-night-sky-90 rounded-md text-lg font-bold"}
         (tr [:continue]))]]]))


(defn submit-success [email]
  (let [tr (<sub [:tr])]
    [:div.flex.flex-col
     [:h2.mt-8.mb-6 (tr [:register/heading-success])]
     [:div.flex.flex-col.items-start.mb-6.leading-snug
      (tr [:register/verification] [email])]]))


(defn view [_ _]
  (rf/dispatch-sync [::init])
  (let [validator #(validate/validate-field % (<sub [::model]) error-messages)]
    (fn [disabled? input-id-suffix]
      [:div.flex.flex-col.items-start.justify-center
       (case (<sub [::state])
         ::done [submit-success (<sub [::user-email])]
         [registration-email-form validator disabled? input-id-suffix])])))
